// Vue necessary imports
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import VueTheMask from 'vue-the-mask'

// CSS imports
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import './css/general.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import 'animate.css/animate.min.css'
import '@mdi/font/css/materialdesignicons.css'

// Plugins, mixins and global components imports
import { ModalComponent, CardToggleComponent } from './components/Components';
import { AlertPlugin }  from './mixins/Alert'
import { ProcessMessage } from './mixins/ProcessMessage'
import money from 'v-money'

Vue.use(AlertPlugin, {
  timeOut: 5000
})

// Plugins registrations
Vue.use(ProcessMessage)
Vue.use(VueCookies)
Vue.use(Buefy)
Vue.use(VueTheMask)
Vue.use(money, {precision: 2})

// Component registrations
Vue.component('modal', ModalComponent)
Vue.component('card-toggle', CardToggleComponent)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
